import React, { PureComponent } from 'react'
import {
  Grid,
  TableRow,
  Table,
  TableHead,
  TableCell,
  Paper,
  Button,
  TableBody,
} from '@material-ui/core'
import FeeItem from '../../components/FeeMinimums/FeeItem'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'
import { hasAccess } from '../../utils/api'
import { openErrorMessage } from '../../actions/message'
import { connect } from 'react-redux'

const FeeItemEditable = EditableHOCWrapper(FeeItem)

class FeeItemContainer extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      showEmptyFee: false,
    }
  }

  toggleEmptyFee = () => {
    this.setState((prevState) => ({
      showEmptyFee: !prevState.showEmptyFee,
    }))
  }

  onSave = (index) => (data, afterSave) => {
    if (this.props.activeTab === 'CASHLESS_ATM') {
      let feeAmount = data && data.fee
      let subTotalMinimum = data && data.subTotalThreshold

      if (isNaN(feeAmount) || feeAmount < 0) {
        return this.props.dispatch(openErrorMessage('Please enter correct fee amount'))
      }

      if (isNaN(subTotalMinimum) || subTotalMinimum < 0) {
        return this.props.dispatch(openErrorMessage('Please enter correct Sub Total Minimum'))
      }
    }
    const { feeList = [] } = this.props
    let updatedFeeList = [...feeList]
    updatedFeeList[index] = { ...updatedFeeList[index], ...data }
    this.props
      .onSave(updatedFeeList, afterSave)
      .then((res) => {
        afterSave && afterSave()
      })
      .catch((err) => {
        console.log(err)
      })
  }

  onSaveNew = (data, afterSave) => {
    const { feeList = [] } = this.props
    let updatedFeeList = [...feeList]
    updatedFeeList && updatedFeeList.unshift({ ...data })
    this.props
      .onSave(updatedFeeList)
      .then((res) => {
        this.toggleEmptyFee()
        afterSave && afterSave()
      })
      .catch((err) => {
        console.log(err)
      })
  }

  onDelete = (index, activeTab) => () => {
    let { feeList = [] } = this.props
    let updatedFeeList = [...feeList]
    if (activeTab === 'CASHLESS_ATM') {
      let listToEdit = { ...(updatedFeeList && updatedFeeList[index]) }
      let updatedListToEdit = {
        ...listToEdit,
        deleted: true,
      }
      updatedFeeList = [...feeList, updatedListToEdit]
      updatedFeeList.splice(index, 1)
      this.props.onSave(updatedFeeList)
    } else {
      updatedFeeList.splice(index, 1)
      this.props.onSave(updatedFeeList)
    }
    // this.confirmDeleteFee.handleClose();
  }

  render() {
    const {
      titles = [],
      feeList = [],
      lastModified,
      config = '',
      cartMinimum = false,
      showFeeType = false,
      activeTab,
      isBLAZEPAY = false,
      isSTRONGHOLD = false,
    } = this.props
    const emptyFee = !cartMinimum
      ? {
          subTotalThreshold: 0,
          fee: 0,
          enabled: false,
          zipCodes: [],
          type: 'Cash',
        }
      : {
          distance: 0,
          minimum: 0,
          enabled: false,
          zipCodes: [],
        }
    const { showEmptyFee = false } = this.state
    const permitted = hasAccess()
    return (
      <Grid container className="paper-page">
        {permitted && !(feeList.length > 9) ? (
          <Grid className="addButton" item lg={12}>
            <Button
              variant="raised"
              className="primary-button pull-right margin-bottom-small"
              onClick={this.toggleEmptyFee}
            >
              Add {cartMinimum ? 'Minimum' : 'Fee'}
            </Button>
          </Grid>
        ) : null}
        <Grid className="unversalScroll" item lg={12}>
          <Paper>
            <div className="table-scroll">
              <Table data-cy="container-feeminimums">
                <TableHead>
                  <TableRow>
                    {titles.map((title, i) => {
                      return <TableCell key={i}>{title}</TableCell>
                    })}
                    {permitted ? <TableCell></TableCell> : null}
                  </TableRow>
                </TableHead>
                <TableBody data-cy="container-item-feeminimums">
                  {showEmptyFee ? (
                    <FeeItemEditable
                      fee={emptyFee}
                      //onChange={this.setChange(shop.id)}
                      onSave={this.onSaveNew}
                      dataToEdit={emptyFee || {}}
                      defaultEditMode={true}
                      onCancel={this.toggleEmptyFee}
                      lastModified={lastModified}
                      config={config}
                      showFeeType={showFeeType}
                      cartMinimum={cartMinimum}
                      activeTab={activeTab}
                      isBLAZEPAY={isBLAZEPAY}
                      isSTRONGHOLD={isSTRONGHOLD}
                    />
                  ) : null}
                  {(feeList &&
                    feeList.length &&
                    feeList.map((fee, index) => {
                      return (
                        <FeeItemEditable
                          fee={fee}
                          key={index}
                          index={index}
                          onDelete={this.onDelete(index, activeTab)}
                          onSave={this.onSave(index)}
                          dataToEdit={fee || {}}
                          lastModified={lastModified}
                          config={config}
                          cartMinimum={cartMinimum}
                          showFeeType={showFeeType}
                          activeTab={activeTab}
                          isBLAZEPAY={isBLAZEPAY}
                          isSTRONGHOLD={isSTRONGHOLD}
                        />
                      )
                    })) ||
                    null}
                </TableBody>
              </Table>
            </div>
          </Paper>
        </Grid>
      </Grid>
    )
  }
}

export default connect(({ dispatch }) => ({
  dispatch,
}))(FeeItemContainer)



// WEBPACK FOOTER //
// ./src/components/FeeMinimums/FeeItemContainer.js